import subscriptions, {
  SubscriptionsProvider,
} from 'modules/expenses/store/collections/subscriptions'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

import Content from './Content'

const ExpensesV2Settings = () => {
  const content = (
    <SubscriptionsProvider collection={subscriptions}>
      <Content />
    </SubscriptionsProvider>
  )

  return <ResponsivePage.Body>{content}</ResponsivePage.Body>
}

export default ExpensesV2Settings
